/**
 * Find an array of elements.
 * Can safely be deleted with @nike/ux-tread-privacy based cookieModal and backing cookies.js utils
 * @deprecated
 * @param selector {String}
 * @param from {HTMLElement} default is document
 * @returns {*}
 */
export function all(selector, from = document) {
  return from ? [...from.querySelectorAll(selector)] : [];
}
